import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { useReportsServiceGetApiReportsLeadsLastDaysCount } from '../../api/generated/queries/queries';
import WidgetCard from '../DashboardWidgets/WidgetCard';

const LeadsCountWidget: React.FC = () => {
  const { data: leadsCount, isLoading, error } = useReportsServiceGetApiReportsLeadsLastDaysCount();

  if (isLoading) {
    return (
      <WidgetCard>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
          <CircularProgress size={24} />
        </Box>
      </WidgetCard>
    );
  }

  if (error) {
    return (
      <WidgetCard>
        <Alert severity="error" sx={{ border: 'none', p: 0 }}>
          Błąd podczas ładowania danych raportów.
        </Alert>
      </WidgetCard>
    );
  }

  // Prepare data for the bar chart
  const chartData = [
    { name: '7 dni', value: leadsCount?.last7Days || 0, label: 'Ostatnie 7 dni' },
    { name: '14 dni', value: leadsCount?.last14Days || 0, label: 'Ostatnie 14 dni' },
    { name: '30 dni', value: leadsCount?.last30Days || 0, label: 'Ostatnie 30 dni' },
    { name: '60 dni', value: leadsCount?.last60Days || 0, label: 'Ostatnie 60 dni' }
  ];

  return (
    <WidgetCard>
      {/* Header */}
      <Box
        mb={1.5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pb={1}
        borderBottom="1px solid"
        borderColor="divider"
      >
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              backgroundColor: '#e8f5e8',
              borderRadius: '50%',
              width: 28,
              height: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 1,
            }}
          >
            <TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 18 }} />
          </Box>
          <Typography variant="subtitle1" fontWeight={600} fontSize="0.95rem">
            Nowi klienci
          </Typography>
        </Box>
      </Box>

      {/* Content - Bar Chart */}
      <Box sx={{ height: 200, mt: 2 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <defs>
              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#06b6d4" />
                <stop offset="100%" stopColor="#2563eb" />
              </linearGradient>
            </defs>
            <XAxis 
              dataKey="name" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <Bar 
              dataKey="value" 
              fill="url(#barGradient)"
              radius={[4, 4, 0, 0]}
            >
              <LabelList 
                dataKey="value" 
                position="top" 
                style={{ 
                  fontSize: '11px', 
                  fill: '#666', 
                  fontWeight: 500 
                }} 
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </WidgetCard>
  );
};

export default LeadsCountWidget;